import React, { useState, useCallback } from "react";
import { useNavigate, useRouteLoaderData, Link } from "react-router-dom";
import Paper from "Components/UI/Paper";
import EndcustomerAccountForm from "Components/Account/EndcustomerAccountForm";
import EndcustomerAccountFormSystem from "Components/Account/EndcustomerAccountFormSystem";
import DeleteDialog from "Components/UI/Dialogs/DeleteDialog";
import useDeleteDialog from "Components/UI/Dialogs/useDeleteDialog";
import usePost from "Hooks/usePost";
import { updateEndcustomerAccount } from "API/swesum";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function EndcustomerAccountCard() {
  const { endcustomerAccount, invoices, endcustomerArticles, endcustomers } =
    useRouteLoaderData("endcustomerAccount");

  const [formData, setFormData] = useState({
    Id: endcustomerAccount.Id,
    EndCustomerId: endcustomerAccount.EndCustomerId,
    Amount: endcustomerAccount.Amount,
    EndCustomerArticleId: endcustomerAccount.EndCustomerArticleId,
    InvoiceId: endcustomerAccount.InvoiceId,
    PrintedId: endcustomerAccount.PrintedId,
    BookRefId: endcustomerAccount.BookRefId ? endcustomerAccount.BookRefId : 0,
    PaymentId: endcustomerAccount.PaymentId,
    ConnectedPrintId: endcustomerAccount.ConnectedPrintId,
    ToAccount: endcustomerAccount.ToAccount,
    FromAccount: endcustomerAccount.FromAccount,
    BookingDate: endcustomerAccount.BookingDate,
    Description: endcustomerAccount.Description,
    CreateTime: endcustomerAccount.CreateTime,
    SystemStatus: endcustomerAccount.SystemStatus,
  });

  const deleteDialog = useDeleteDialog(false);
  const { openSuccess, openError } = usePopupNotificationContext();
  const navigate = useNavigate();
  const updateEndcustomerAccReq = usePost({
    mtnFunc: (body) => {
      return updateEndcustomerAccount(endcustomerAccount.Id, body);
    },
    onSuccess: (data) => {
      openSuccess(`Sparat! ${data.ParseMessage && data.ParseMessage} `, 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått", 3000);
    },
  });

  const deleteEndcustomerAccReq = usePost({
    mtnFunc: (inputs) => {
      return () => console.log("endpoint hasnt been implemented yet");
    },
    onSuccess: (data) => {
      navigate("/endcustomerssaccounts");
    },
    onError: () => {
      deleteDialog.close();
      openError("Ett fel har uppstått.", 3000);
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );
  const [tabIndex, setTabindex] = useState(0);

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Slutkundskonto
            </Typography>
            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Allmänt" />
              <Tab label="System" />
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
              <EndcustomerAccountForm
                formData={formData}
                invoices={invoices}
                endcustomers={endcustomers}
                endcustomerArticles={endcustomerArticles}
                handleInputChange={handleInputChange}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <EndcustomerAccountFormSystem
                formData={formData}
                invoices={invoices}
                endcustomerArticles={endcustomerArticles}
                handleInputChange={handleInputChange}
              />
            </TabPanel>

            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)}>Stäng</Button>
              <Button
                onClick={() => updateEndcustomerAccReq.post(formData)}
                variant="contained"
                sx={{ ml: 3 }}
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <DeleteDialog
        title={"Ta bort slutkundskonto"}
        isOpen={deleteDialog.isOpen}
        handleClose={deleteDialog.close}
        handleDelete={() => deleteEndcustomerAccReq.post()}
      >
        Slutkundskontot kommer att tas bort.
      </DeleteDialog>
    </>
  );
}
